<template>
    <div class="wrap-position-introduce">
        <header-app></header-app>
        <div class="introcuce-bg"></div>
        <div class="introcuce-desc animation">
            <div class="img animation" >
                <img src="../../static/images/introduce_thumb.png"/>
            </div>
            <h3 class="title">INTRODUCTION</h3>
            <p class="desc">Jack Trout pioneered “Positioning”. He wrote the first article on the subject of positioning in 1969. He also wrote three books on the subject, “Positioning: The B e for Your Mind” in 1981, “The New Positioning” in 1996 and “Repositioning: Marketing in an Era of Competition, Change and Crisis” in 2010. His concept of Positioning has become the world's #1 business strategy.</p>
        </div>
        <div class="article animation">
            <p class="line">Jack Trout is the originator of other important concepts in marketing strategy. He wrote many marketing classics published in many languages: Marketing Warfare, Bottom Up Marketing, The 22 Immutable Laws of Marketing, Horse Sense, Differentiate or Die, Big Brands Big Trouble, A Genie's Wisdom, Trout on Strategy, The Power of Simplicity, and In Search of the Obvious.</p>
            <p class="line">He had over 40 years of experience in advertising and marketing, and became a boardroom advisor to some of the world's largest corporations and his worldwide consulting work gave him first-hand experience in a wide range of marketing scenarios. Jack Trout gained an international reputation as a consultant, writer, speaker, and proponent of leading-edge marketing strategies.</p>
            <p class="line">He is the founder of Trout & Partners. Together with other talented consultants, Mr. Trout created an international network of consultant boutiques which offer preeminent skills and hands-on experience in the implementation of Positioning Strategies. The firm has done work for AT&T, IBM, Southwest Airlines and many other Fortune 500 companies.</p>
        </div>
        <bottom-app></bottom-app>
        <top-scroll></top-scroll>
    </div>
</template>

<script>
    import bottomApp from '@/components/bottomApp.vue'
    import topScroll from '@/components/topScroll.vue'
    import headerApp from '@/components/headerApp.vue'
    export default {
        components: {
            headerApp,
            bottomApp,
            topScroll
        },
    }
</script>

<style lang="less" rel="stylesheet/less">
    .wrap-position-introduce{
        text-align: left;
        .introcuce-bg{
            height: 4rem;
            background: url("../../assets/imgs/tp-introduce-bg.jpg") no-repeat top center;
            background-size:100%;
            position: relative;
        }
        .introcuce-desc{
            padding: 2.5rem .5rem .5rem .5rem;
            box-sizing: border-box;
            background: url("../../assets/imgs/introduce_bg_1.png") no-repeat center center;
            background-size: cover;
            box-shadow: 0 0 20px rgba(0,0,0,.2);
            position: relative;
            .img{
                position: absolute;
                width: 3.2rem;
                height: 4rem;
                top: -30%;
                left: 50%;
                margin-left: -1.6rem;
                z-index: 2;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .title{
                font-size: .48rem;
                color: #6b6b6b;
                position: relative;
                height: .8rem;
                line-height: .8rem;
                &:after{
                    content: '';
                    display: inline-block;
                    width: 1rem;
                    height: .05rem;
                    background: #ed1d25;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    animation: line-left-in-long 0.5s ease 0.8s;
                    animation-fill-mode: both;
                }
            }
            .desc{
                color: #2d2d2d;
                font-size: .28rem;
                line-height: 1.5;
                padding-top: .3rem;
            }
        }
        .article{
            padding: 0 .5rem .9rem 1.3rem;
            position: relative;
            &:after{
                content: " “ ";
                position: absolute;
                left: .2rem;
                top: .76rem;
                font-size: 1.2rem;
                color: #ed1d25;
            }
            .line{
                color: #2d2d2d;
                font-size: .28rem;
                padding-top: .9rem;
                line-height: 1.5;
            }
        }
        .animation {
            position: relative;
            animation: animation-up 1s ease;
        }
        @-webkit-keyframes animation-up{
            0%{bottom: -5rem;}
            100%{bottom: 0;}
        }
    }
</style>
